import { DataTableSkeleton } from "@/components/data-tables/data-table-skeleton";
import UserGroupDataTable from "@/components/data-tables/user-groups/UserGroupDataTable";
import { useUserGroupsQuery } from "@/api/queries/admin/UserGroupQueries";
import { useTranslation } from "react-i18next";

const UserGroupsSection = () => {
    const { data, isLoading } = useUserGroupsQuery({ page: 1, per_page: 100 });
    const { t } = useTranslation();

    return (
        <section className="flex flex-col gap-4">
            <div className="space-y-2">
                <h2 className="text-2xl font-semibold">{t("admin.userGroups.title")}</h2>
                <p className="text-gray-500">
                    {t("admin.userGroups.description")}
                </p>
            </div>

            {isLoading ? (
                <DataTableSkeleton
                    rowCount={5}
                    columnCount={5}
                    searchableColumnCount={2}
                    filterableColumnCount={0}
                    extraButtonsCount={1}
                />
            ) : (
                <UserGroupDataTable data={data?.data || []} />
            )}
        </section>
    );
};

export default UserGroupsSection;
